// 무빈소 신규 퍼널 리드 제출 시 #홈 질문으로 보낼 사람용 스토리 빌더.
// CTA 성격(info/consult) + 찾기 퍼널 여부(region)로 본문이 달라진다.
// v2: 헤더·전화번호·🚨·임박도(status)·ops멘션은 BE/구조화 필드가 처리. 여기선 스토리만.

export interface MubinsoLeadMessageParams {
  /**
   * 눌린 CTA 성격.
   * info=자료(정보) 요청, consult=상담 요청,
   * check=가능 장례식장과 예상 비용 통합 확인 요청(절차 퍼널 주 CTA).
   */
  ctaType: "info" | "consult" | "check";
  /** 상황 답변(임박도). "임종" 포함 시 임종/임박으로 간주해 ops 태그. */
  situation: string;
  /** 주제 답변(궁금한 점) */
  topic: string;
  /** 찾기 퍼널 희망 지역 "{시도} {시군구}". 있으면 지역 라인 추가 + info 본문이 장례식장 찾기용으로 바뀜. */
  region?: string;
  /**
   * 찾기 퍼널 관심 장례식장 체크(B안)에서 고른 이름들. 비어 있으면 줄을 만들지 않는다.
   *
   * 리드(POST /v2/leads/)에는 장례식장을 담을 구조화 필드가 없어 슬랙 메시지에 싣는다.
   * 지역 비용 프레임 C안이 같은 값을 견적 memo 에 싣는 것과 같은 자리다.
   */
  parlors?: string[];
}

export function buildMubinsoLeadMessage({
  ctaType,
  situation,
  topic,
  region,
  parlors,
}: MubinsoLeadMessageParams): string {
  let body: string;
  if (ctaType === "consult") {
    // 상담 요청(msg2 / msg4)
    body = "무빈소 장례 상담을 요청하신 고객님입니다.\n상황 확인 후, 추가적인 세일즈 부탁드립니다.";
  } else if (ctaType === "check") {
    // 통합 확인 요청(절차 퍼널 주 CTA). 지역을 물어봐야 답이 나오는 요청이라 안내 순서를 명시.
    body =
      "무빈소 가능 장례식장과 예상 비용을 함께 확인하고 싶어하는 고객님입니다.\n지역 확인 후 가능 장례식장과 예상 비용을 안내하고, 추가적인 세일즈 부탁드립니다.";
  } else if (region) {
    // 찾기 퍼널 자료 요청(msg3)
    body =
      "무빈소 장례가 가능한 장례식장을 찾고 있는 고객님입니다.\n추천 장례식장과 예상 비용 안내 후, 추가적인 세일즈 부탁드립니다.";
  } else {
    // 일반 자료 요청(msg1)
    body =
      "무빈소 장례에 대해 정보를 요청하신 고객님입니다.\n궁금한 점 내용에 맞게 상담을 진행하고, 추가적인 세일즈 부탁드립니다.";
  }

  // 라벨 뒤 실제 값은 Slack bold(*...*) 처리.
  const regionLine = region ? `\n희망 지역 : *${region}*` : "";
  // 나열은 가운뎃점이 아니라 콤마로 잇는다.
  const parlorLine = parlors?.length ? `\n관심 장례식장 : *${parlors.join(", ")}*` : "";

  return `질문 내용 : *무빈소 장례 문의*\n\n궁금한 점: *${topic}*\n-----\n${body}${regionLine}${parlorLine}`;
}
